export const ru = {
    'banner-connot-update-archived': 'Нельзя редактировать архивное объявление',
    'banner-creative-not-supported':
        'Выберите видеоролик, соответствующий техническим требованиям.',
    'banner-creative-required': 'Загрузите креатив',
    'banner-image-required': 'Загрузите изображение',
    'banner-image-size-modification':
        'Можно заменить только на изображение такого же размера',
    'banner-image-size-modification-adaptive':
        'Можно заменить только на изображение такого же размера (адаптивный)',
    'banner-image-size-modification-with-size':
        'Можно заменить только на изображение такого же размера ({size})',
    'banner-invalid-sitelinkset-usage':
        'Если указаны быстрые ссылки, то должна быть указана и ссылка на сайт.',
    'banner-required-href': 'Укажите ссылку на сайт',
    'banner-required-href-or-vcard':
        'Укажите ссылку на сайт, создайте турбо-страницу или заполните виртуальную визитку',
    'banner-required-href-turbo-vcard-organization':
        'Укажите ссылку на сайт, создайте Турбо-страницу, заполните виртуальную визитку или привяжите организацию Яндекс.Справочника',
    'banners-text-language-inconsistent-with-geo-belarusian':
        'Текст объявления написан на белорусском языке и не соответствует выбранному региону показа. Показы возможны только в Беларуси.',
    'banners-text-language-inconsistent-with-geo-default':
        'Язык текста объявления не соответствует выбранному региону показа.',
    'banners-text-language-inconsistent-with-geo-kazakh':
        'Текст объявления написан на казахском языке и не соответствует выбранному региону показа. Показы возможны только в Казахстане.',
    'banners-text-language-inconsistent-with-geo-turkish':
        'Текст объявления написан на турецком языке и не соответствует выбранному региону показа. Показы возможны только в Турции.',
    'banners-text-language-inconsistent-with-geo-ukraine':
        'Текст объявления написан на украинском языке и не соответствует выбранному региону показа. Показы возможны только в Украине.',
    'body-invalid-template-query': 'Шаблон можно использовать только один раз.',
    'body-max-length':
        'Превышена допустимая длина рекламного текста в {maxLength} символ',
    'body-max-narrow-length':
        'В рекламном тексте вы можете использовать не более {maxLength} точек, запятых, двоеточий, точек с запятой, кавычек и восклицательных знаков',
    'body-max-world-length':
        'В рекламном тексте недопустимы слова длиной более {maxLength} символов',
    'body-restricted-chars-in-field':
        'В тексте рекламного сообщения можно использовать только буквы латинского, турецкого, русского, украинского, белорусского или казахского алфавита, цифры и знаки препинания.',
    'body-should-not-be-blank': 'Напишите текст объявления',
    'callout-text-cannot-be-empty': 'Напишите текст уточнения',
    'callout-text-length-exceeded': 'Превышена длина уточнения',
    'callout-text-not-allowed-symbols':
        'В тексте уточнений можно использовать только буквы латинского, турецкого, русского, украинского, казахского или белорусского алфавита, знаки препинания, за исключением «!»,«?».',
    'callout-unknown-error':
        'Произошла ошибка при выполнении запроса. Повторите попытку позже',
    'callout-used':
        'Невозможно удалить уточнение, которое связано с другим объявлением',
    'callouts-max-size':
        'Для одного объявления можно задать не более {maxSize} уточнений',
    'cannot-be-empty': 'Поле не может быть пустым',
    'choose-correct-template': 'Выберите корректный шаблон',
    'description-cannot-be-less-than-max':
        'Минимальное количество символов - {minLength}',
    'description-cannot-be-more-than-max':
        'Максимальное количество символов - {maxLength}',
    'display-href-invalid-template-query':
        'Шаблон можно использовать только один раз',
    'displayhref-max-length':
        'Превышена допустимая длина отображаемой ссылки в {maxLength} символов',
    'domain-invalid-value': 'Неправильный формат домена',
    'duplicate-error':
        'При массовом изменении можно выбрать только одно изображение для каждого размера',
    'equal-pixels':
        'Счётчики показов следующих провайдеров указаны более одного раза: {providerNames}.',
    'gif-file-error-text': 'Невозможно обработать gif-файл',
    'href-file-format-invalid':
        'Не удалось загрузить изображение по ссылке. Сервер вернул ошибку 400',
    'href-file-invalid': 'Неправильный формат файла',
    'href-image-file-size-invalid': 'Размер файла слишком большой',
    'href-invalid': 'Неправильный формат ссылки',
    'href-invalid-or-no-scheme':
        'Неправильный формат ссылки или не указана схема',
    'href-invalid-or-not-https-scheme':
        'Неправильный формат ссылки или не https схема',
    'href-invalid-value': 'Неправильный формат ссылки',
    'href-max-length':
        'Превышена допустимая длина ссылки в {maxLength} символа',
    'href-null': 'Ссылка не может быть пустой',
    'href-or-turbo-required':
        'Укажите ссылку на сайт или создайте турбо-страницу',
    'href-should-not-be-blank': 'Укажите ссылку на сайт',
    'image-gallery-empty-images': 'В галерее нет изображений',
    'image-invalid-file-size-param':
        'Размер файла больше допустимого ({maxSize} КБ)',
    'image-invalid-format':
        'Недопустимый тип файла, используйте графические форматы GIF, JPEG, PNG',
    'image-invalid-formats':
        'Недопустимый тип файла, используйте графические форматы: {formats}',
    'image-invalid-sizes': 'Недопустимый размер изображения',
    'image-invalid-sizes-mc-banner': 'Используйте креатив размером 240х400 px',
    'image-not-equal': 'Размер изображения не соответствует требованиям',
    'image-not-equal-height':
        'Размер изображения не соответствует требованиям по высоте: {height} пикселей',
    'image-not-equal-width':
        'Размер изображения не соответствует требованиям по ширине: {width} пикселей',
    'image-not-equal-width-height':
        'Размер изображения не соответствует требованиям: {width} × {height} пикселей',
    'image-too-big': 'Размер изображения больше допустимых ограничений',
    'image-too-big-height':
        'Размер изображения больше допустимых ограничений по высоте: {height} пикселей',
    'image-too-big-width':
        'Размер изображения больше допустимых ограничений по ширине: {width} пикселей',
    'image-too-big-width-height':
        'Размер изображения больше допустимых ограничений: {width} × {height} пикселей',
    'image-too-small': 'Размер изображения меньше допустимых ограничений',
    'image-too-small-height':
        'Размер изображения меньше допустимых ограничений по высоте: {height} пикселей',
    'image-too-small-width':
        'Размер изображения меньше допустимых ограничений по ширине: {width} пикселей',
    'image-too-small-width-height':
        'Размер изображения меньше допустимых ограничений: {width} × {height} пикселей',
    'incorrect-measures': 'Неправильный формат.',
    'incorrect-pixel-url':
        'Введенный вами код не соответствует формату допустимых счетчиков.',
    'incorrect-ya-auditory-pixel-url':
        'Введенный вами код не соответствует формату кода пикселя Яндекс.Аудиторий. Для получения кода пикселя воспользуйтесь сервисом Яндекс Аудитории',
    'invalid-choice-value': 'Выбрано недопустимое значение',
    'must-be-empty': 'Поле должно быть пустым',
    'no-right-to-pixel':
        'Неправильный формат счетчика. Для сбора статистики вы можете использовать счетчик {counters}. Ссылка должна содержать макрос %random%.',
    or: 'или',
    'organization-not-found':
        'Выбранная организация не найдена в Я.Справочнике',
    'template-not-allowed': 'Выбранный шаблон не доступен',
    'title-invalid-template-query': 'Можно использовать шаблон только один раз',
    'title-max-length':
        'Превышена допустимая длина заголовка в {maxLength} символов',
    'title-max-length-word':
        'В заголовке недопустимы слова длиной более {maxLength} символов',
    'title-max-narrow-length':
        'В заголовке можно использовать не более {maxLength} точек, запятых, двоеточий, точек с запятой, кавычек и восклицательных знаков',
    'title-restricted-chars-in-field':
        'В заголовке можно использовать только буквы латинского, турецкого, русского, украинского, белорусского или казахского алфавита, цифры и знаки препинания',
    'title-should-not-be-blank': 'Укажите заголовок',
    'tns-id-cannot-be-empty': 'Поле не может быть пустым',
    'tns-id-empty-pixels': 'Нельзя указать TNS ID, не указав счётчик показов',
    'tns-id-length': {
        one: 'Превышена допустимая длина TNS ID в {maxLength} символ',
        some: 'Превышена допустимая длина TNS ID в {maxLength} символа',
        many: 'Превышена допустимая длина TNS ID в {maxLength} символов',
        none: 'Превышена допустимая длина TNS ID в {maxLength} символов'
    },
    'tns-id-restricted-characters': 'Поле содержит недопустимые символы',
    'turbo-gallery-href-max-length':
        'Превышена допустимая длина ссылки на обогащенный интерактивный ответ в {maxLength} символов',
    'turbo-href-params-length':
        'Превышена допустимая длина трекинговых параметров в {maxLength} символа',
    'turbo-required': 'Необходимо выбрать Турбо-страницу',
    'unknown-error-header': 'Произошла непредвиденная ошибка',
    'unknown-error-text':
        'Произошла непредвиденная ошибка. Повторите попытку позже'
};
